import { render, staticRenderFns } from "./marketing-content-translations-modal.vue?vue&type=template&id=6e201d48&scoped=true&"
import script from "./marketing-content-translations-modal.vue?vue&type=script&lang=js&"
export * from "./marketing-content-translations-modal.vue?vue&type=script&lang=js&"
import style0 from "./marketing-content-translations-modal.vue?vue&type=style&index=0&id=6e201d48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e201d48",
  null
  
)

export default component.exports